import dateTimeDecorator from '../services/dateTimeDecorator';
import * as attendeeFuncs from '../services/attendees';

import * as eventList from '../actions/eventList';

import moment from 'moment';

var defaultState = {
    attendeeSorts: {},
    filterDate: moment().format('YYYY-MM-DD 00:00 Z').toString(),
    addingAttendeeToEventId: null,
    isAddAttendeeOverlayOpen: false,
    isEditAttendeeOverlayOpen: false,
    isDeleteAttendeeOverlayOpen: false,
    attendeeToAdd: null,
    attendeeToEdit: null,
    attendeeToDelete: null,
    formMode: 'add',
    isNewEventOverlayOpen: false,
    isDeleteEventOverlayOpen: false,
    isEditEventOverlayOpen: false,
    eventToDelete: null,
    eventToEdit: null,
    eventsShowingAttendees: [],
    events: [],
    timetables: [],
    courses: [],
    venues: [],
    presenters: [],
    resourcePacks: [],
    websiteDisplayPositionsAvailable: [],
    defaultEvent: {
        id: 0,
        start_date: null,
        start_time: '00:00',
        end_date: null,
        end_time: '00:00',
        course_id: 1,
        timetable_id: 1,
        venue_id: 1,
        private_price: '0.00',
        public_price: '0.00',
        override_price: false,
        overridden_price: null,
        max_delegates: null,
        resource_code: null,
        presenters: [],
        resource_packs: [],
    }
};

export default function(state = defaultState, action) {

    switch (action.type) {

        case eventList.SORT_EVENT_ATTENDEES: {

            const { eventId, attribute, direction } = action;

            return {
                ...state,
                attendeeSorts: attendeeFuncs.getUpdatedAttendeeSorts(state.events, eventId, attribute, direction),
                events: state.events.map((event) => {

                    if (event.id === action.eventId) {

                        return {
                            ...event,
                            attendees: attendeeFuncs.sortAttendees(event.attendees, attribute, direction)
                        }

                    } else {

                        return event;
                    }
                })
            };
        }

        case eventList.EVENT_FILTER_DATE_CHANGED: {

            if (action.fromDate) {

                return {
                    ...state,
                    filterDate: moment(action.fromDate).format('YYYY-MM-DD 00:00 Z').toString()
                };

            } else {

                return {
                    ...state,
                    filterDate: null
                };
            }
        }

        case eventList.RESET_SELECT_ALL_ATTENDEES: {

            return {
                ...state,
                events: attendeeFuncs.resetSelectAllAttendees(state.events, action.eventId)
            };
        }

        case eventList.TOGGLE_SELECT_ALL_ATTENDEES: {

            return {
                ...state,
                events: attendeeFuncs.toggleSelectAllAttendees(state.events, action.eventId)
            };
        }

        case eventList.ATTENDEE_SELECT_CHANGED: {

            return {
                ...state,
                events: attendeeFuncs.setSelectedAttendee(state.events, action.eventId, action.attendeeId, action.isSelected)
            };
        }

        case eventList.SHOW_ADD_ATTENDEE_OVERLAY: {

            return {
                ...state,
                isAddAttendeeOverlayOpen: true,
                addingAttendeeToEventId: action.eventId
            };
        }

        case eventList.HIDE_ADD_ATTENDEE_OVERLAY: {

            return {
                ...state,
                isAddAttendeeOverlayOpen: false,
                addingAttendeeToEventId: null,
                attendeeToAdd: null
            };
        }

        case eventList.HIDE_EDIT_ATTENDEE_OVERLAY: {

            return {
                ...state,
                isEditAttendeeOverlayOpen: false,
                attendeeToEdit: null
            };
        }

        case eventList.HIDE_DELETE_ATTENDEE_OVERLAY: {

            return {
                ...state,
                isDeleteAttendeeOverlayOpen: false,
                attendeeToDelete: null
            };
        }

        case eventList.SHOW_EDIT_ATTENDEE_OVERLAY: {

            return {
                ...state,
                isEditAttendeeOverlayOpen: true,
                attendeeToEdit: action.attendee
            };
        }

        case eventList.SHOW_DELETE_ATTENDEE_OVERLAY: {

            return {
                ...state,
                isDeleteAttendeeOverlayOpen: true,
                attendeeToDelete: action.attendee
            };
        }

        case eventList.HIDE_EDIT_EVENT_OVERLAY: {

            return {
                ...state,
                isEditEventOverlayOpen: false
            };
        }

        case eventList.SHOW_EDIT_EVENT_OVERLAY: {

            return {
                ...state,
                isEditEventOverlayOpen: true,
                formMode: 'edit',
                eventToEdit: dateTimeDecorator.decorateStartEndDateTime(action.event)
            };
        }

        case eventList.SHOW_DELETE_EVENT_OVERLAY: {

            return {
                ...state,
                isDeleteEventOverlayOpen: true,
                eventToDelete: action.event
            };
        }

        case eventList.HIDE_DELETE_EVENT_OVERLAY: {

            return {
                ...state,
                isDeleteEventOverlayOpen: false
            };
        }

        case eventList.COURSES_REFRESHED: {

            return {
                ...state,
                courses: action.courses
            };
        }

        case eventList.VENUES_REFRESHED: {

            return {
                ...state,
                venues: action.venues
            };
        }

        case eventList.RESOURCE_PACKS_REFRESHED: {

            return {
                ...state,
                resourcePacks: action.resourcePacks
            };
        }

        case eventList.PRESENTERS_REFRESHED: {

            return {
                ...state,
                presenters: action.presenters
            };
        }

        case eventList.TIMETABLES_REFRESHED: {

            return {
                ...state,
                timetables: action.timetables
            };
        }

        case eventList.HIDE_NEW_EVENT_OVERLAY: {

            return {
                ...state,
                isNewEventOverlayOpen: false
            };
        }

        case eventList.SHOW_NEW_EVENT_OVERLAY: {

            return {
                ...state,
                isNewEventOverlayOpen: true,
                formMode: 'add'
            };
        }

        case eventList.SHOW_EVENT_ATTENDEES: {

            const events = state.eventsShowingAttendees.concat(action.eventId);

            return {
                ...state,
                eventsShowingAttendees: events
            };
        }

        case eventList.HIDE_EVENT_ATTENDEES: {

            const events = state.eventsShowingAttendees.filter(id => id !== action.eventId);

            return {
                ...state,
                eventsShowingAttendees: events
            };
        }

        case eventList.EVENTS_REFRESHED: {

            const attendeeSorts = action.events.reduce((map, event) => {

                map[event.id] = {
                    organisation: null,
                    last_name: null
                };

                return map;

            }, {});

            return {
                ...state,
                attendeeSorts,
                events: action.events
            };

        }

        case eventList.PUBLIC_EVENTS_REFRESHED: {
            return {
                ...state,
                events: action.events
            };
        }

        case eventList.WEBSITE_DISPLAY_POSITIONS_AVAILABLE: {
            return {
                ...state,
                websiteDisplayPositionsAvailable: action.websiteDisplayPositionsAvailable
            };
        }

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./reducers/adminEventList.js